import { addDays, format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

/** Days after checkout the scrub task deletes guest data (server RETENTION_DAYS). */
export const GUEST_DATA_RETENTION_DAYS = 90

type GuestDataRetentionBannerProps = {
  checkoutDate: string | Date
}

/** Reservation-level notice that guest survey and TRA/SIRE data is purged after checkout. */
export function GuestDataRetentionBanner({ checkoutDate }: GuestDataRetentionBannerProps) {
  const { t } = useTranslation()
  const deletionDate = format(
    addDays(new Date(checkoutDate), GUEST_DATA_RETENTION_DAYS),
    'MMM d, yyyy',
  )

  return (
    <div
      data-testid="guest-data-retention-banner"
      role="note"
      className="flex items-start gap-3 rounded-lg border border-warning bg-yellow-50 p-4"
    >
      <ExclamationTriangleIcon
        className="mt-0.5 h-5 w-5 shrink-0 text-yellow-700"
        aria-hidden="true"
      />
      <div className="text-sm text-yellow-900">
        <p className="font-medium">{t('reservations.guestDataRetention')}</p>
        <p className="mt-1">{t('reservations.guestDataRetentionDate', { date: deletionDate })}</p>
      </div>
    </div>
  )
}
